export default {
  global: {
    isMiniCartOpen: false,
  },
};
